export default __webpack_public_path__ + "static/media/brandWhite.fe1a28aa.svg";